<template>
	<!-- 应用中心首页 -->
	<v-container fluid class="px-0" style="height: 100%">
		<div class="pb-3" style="width: 100%; height: 100%">
			<v-card class="ma-3" style="height: 100%" elevation="0">
				<v-card-title>
					<v-btn @click="$router.push('/uams/apps')" color="blue" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
					开发中心
				</v-card-title>
				<v-toolbar flat color="rgba(0,0,0,0)">
					<v-btn-toggle v-model="btnValue" color="primary" mandatory dense group class="ml-n2">
						<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index" :to="item.url">{{ item.val }}</v-btn>
					</v-btn-toggle>
				</v-toolbar>
				<v-card-text class="pt-0">
					<div class="pl-4 font-weight-bold" style="background: rgba(204, 204, 204, 0.215); height: 48px; line-height: 48px; font-size: 0.75rem">单位</div>
					<div class="py-3 pl-3">
						<p :title="entView.entName" class="title">
							{{ entView.entName }}
							<v-chip class="ml-1" :class="entView.state | dict('0:red lighten-5  red--text/1:green lighten-5  green--text')" small label>
								{{ entView.state | dict("0:未启用/1:已启用") }}
							</v-chip>
						</p>
						<p>信用证号：{{ entView.entCode }}</p>
						<p>限制IP：{{ entView.ip }}</p>
						<p>
							开发账号：
							<v-hover>
								<template v-slot:default="{ hover }">
									<span v-if="accountShow" @click="copy('开发账号：' + entView.corpId)" :class="hover ? 'copy_hover' : ''" class="vtk-cursor-pointer">{{ entView.corpId }}</span>
									<span v-else @click="copy('开发账号：' + entView.corpId)" :class="hover ? 'copy_hover' : ''" class="vtk-cursor-pointer" style="letter-spacing: 1.72px"
										>{{ entView.corpId?.slice(0, 4) }}************************{{ entView.corpId?.slice(entView.corpId.length - 4) }}</span
									>
								</template>
							</v-hover>
							<v-icon @click="accountShow = !accountShow" size="20" class="ml-2 vtk-cursor-pointer">{{ accountShow ? "mdi-eye-outline" : "mdi-eye-off-outline" }}</v-icon>
						</p>
						<p>
							开发秘钥：
							<v-hover>
								<template v-slot:default="{ hover }">
									<span v-if="keyShow" @click="copy('开发秘钥：' + entView.corpSecret)" :class="hover ? 'copy_hover' : ''" class="vtk-cursor-pointer">{{ entView.corpSecret }}</span>
									<span v-else @click="copy('开发秘钥：' + entView.corpSecret)" :class="hover ? 'copy_hover' : ''" class="vtk-cursor-pointer" style="letter-spacing: 1.62px"
										>{{ entView.corpSecret?.slice(0, 4) }}************************{{ entView.corpSecret?.slice(entView.corpSecret.length - 4) }}</span
									>
								</template>
							</v-hover>
							<v-icon @click="keyShow = !keyShow" size="20" class="ml-2 vtk-cursor-pointer">{{ keyShow ? "mdi-eye-outline" : "mdi-eye-off-outline" }}</v-icon>
						</p>
					</div>
				</v-card-text>
			</v-card>
		</div>
	</v-container>
</template>
<script>
import Message from "@/components/message";
import Storage from "@/commons/storage";
import Request from "@/commons/request";
export default {
	data: () => ({
		btnGroup: [
			{ key: "1", val: "开发单位", url: "/uams/apps-acid" },
			{ key: "2", val: "开发文档", url: "/uams/apps-docu" },
			{ key: "3", val: "服务接口", url: "/uams/apps-apis" },
			{ key: "0", val: "服务目录", url: "/uams/apps-abiz" },
		],
		btnValue: "1",
		user: {},
		entView: {},
		accountShow: false,
		keyShow: false,
	}),
	mounted() {
		this.user = Storage.get("_wit_acis_users");
		this.view();
	},
	methods: {
		view() {
			Request.postForm("/app/acid/view", { entCode: this.user.uniCode }).then((res) => {
				if (res.meta.success) {
					this.entView = res.data;
				}
			});
		},
		//拷贝文本
		copy(txt) {
			navigator.clipboard.writeText(txt).then(() => {
				Message.toast("复制成功", { color: "success" });
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.title_box {
	display: inline-block;
	min-width: 88px;
	text-align: justify;
	text-align-last: justify;
}
::v-deep .v-data-table > .v-data-table__wrapper > table th {
	background: rgba(204, 204, 204, 0.215);
}
.copy_hover {
	background: rgba(162, 201, 255, 0.297);
	&::after {
		content: " 复制";
		color: rgb(0, 102, 255);
	}
}
</style>
